module.exports = __webpack_public_path__ + "img/2.26cd0324.png";